<template>
  <ion-toolbar>
    <ion-title>My Profile</ion-title>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="user_info_wrapper page_padding_top container">
      <div class="image_text_comp">
        <el-button type="transparent" class="image_wrapper" @click="links.changePhoto" data-testid="avatar-btn">
          <el-avatar :size="'medium'" :shape="user.role == 'locum' || user.role == 'agency'  ? 'circle' : 'square'"
            :src="user.image" v-if="user.image" />
          <el-avatar :size="'medium'" :shape="user.role == 'locum' || user.role == 'agency'  ? 'circle' : 'square'"
            icon="el-icon-user-solid" v-else></el-avatar>
          <!-- <span class="locumate_icons locumate_icon-camera"></span> -->
          <span class="locumate_icons">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.76017 22H17.2402C20.0002 22 21.1002 20.31 21.2302 18.25L21.7502 9.99C21.8902 7.83 20.1702 6 18.0002 6C17.3902 6 16.8302 5.65 16.5502 5.11L15.8302 3.66C15.3702 2.75 14.1702 2 13.1502 2H10.8602C9.83017 2 8.63017 2.75 8.17017 3.66L7.45017 5.11C7.17017 5.65 6.61017 6 6.00017 6C3.83017 6 2.11017 7.83 2.25017 9.99L2.77017 18.25C2.89017 20.31 4.00017 22 6.76017 22Z"
                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M10.5 8H13.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M12 18C13.79 18 15.25 16.54 15.25 14.75C15.25 12.96 13.79 11.5 12 11.5C10.21 11.5 8.75 12.96 8.75 14.75C8.75 16.54 10.21 18 12 18Z"
                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>

        </el-button>
        <div class="text_wrapper">
          <div class="main_text">{{ user.name }}</div>

          <div class="additional_text" v-if="user.role == 'locum'">
            {{ formatAhpraDisplay(user) || registrationNumberMessage() }}
          </div>
          <div class="additional_text" v-else-if="user.role == 'pharmacy'">
            {{ $filters.addressText(user.address) }}
          </div>
          <div class="additional_text" v-else-if="user.role === 'locum'">"Admin mode"</div>
          <!-- <el-button v-if="user.role == 'locum' && user.isInternalLocum && !user.enableMarketplaceProcessComplete"
            type="link" class="update_profile" @click="links.changeBasicProfileOfIE" data-testid="update-details-btn">
            <span>Update Details</span>
          </el-button> -->
          <div v-if="user.role == 'pharmacy' && user.groupName"> <span class="group-name">Group name: {{ user.groupName }}</span></div>
          <el-button v-if="user.role == 'locum' && user.isInternalLocum && !user.enableMarketplaceProcessComplete"
            type="link" class="update_profile" @click="links.changeProfile" data-testid="update-details-btn">
            <span>Update Details</span>
          </el-button>
          <el-button v-else type="link" class="update_profile" @click="links.changeProfile"
            data-testid="update-details-btn">
            <span>Update Details</span>
          </el-button>
        </div>
      </div>

      <div class="settings-separator" v-if="isAustralia && (user.role == 'locum' || ((user.role == 'pharmacy' && $filters.employerType(user).isCommunityPharmacy) && showCreateOptions('isRecordShiftsEnabled') && active))"></div>
      <div class="settings-separator" v-if="isUS && (user.role == 'locum' || ((user.role == 'pharmacy' && $filters.employerType(user)) && showCreateOptions('isRecordShiftsEnabled') && active))"></div>
      <div class="settings_menu profile_menu" v-if="user.role == 'locum'">
        <div class="menu_title">Available Days</div>
        <div class="user_schedule">
          <span v-if="!user.schedule">You have no schedule</span>
          <div v-else class="shift_day" :class="value == 1 ? 'check' : 'cross'" v-for="(value, day) in user.schedule"
            :key="day">
            <span class="locumate_icons" :class="
                  value == 1 ? 'locumate_icon-check' : 'locumate_icon-close'
                "></span>
            <span class="day_name">
              {{ $filters.capitalize(day.slice(0, 3)) }}</span>
          </div>
        </div>
      </div>
      <div class="settings-separator" v-if="user.role === 'locum'" />

      <div class="settings_menu profile_menu">
        <template v-if="user.role == 'locum'">
          <div class="locum_status my-3">
            <div class="locum_card primary">
              <div class="text_wrapper text-center">
                <div class="main_text text-white">
                  {{ user.completedCancelledShiftsData.completedShiftsCount }}
                </div>
                <div class="additional_text text-white">
                  Completed Shifts
                </div>
              </div>
            </div>
            <div class="locum_card secondary">
              <div class="text_wrapper text-center">
                <div class="main_text text-white">
                  {{ user.completedCancelledShiftsData.cancelledShiftsCount }}
                </div>
                <div class="additional_text text-white">
                  Cancelled Shifts
                </div>
              </div>
            </div>
            <!-- <div class="locum_card">
              <div class="text_wrapper">
                <div class="main_text"><small>Cancellation Ratio</small></div>
                <div class="additional_text"> {{ user.completedCancelledShiftsData.cancellationRate }} </div>
              </div>
            </div> -->
          </div>
          <!-- <div class="menu_item">
            <span class="locumate_icons locumate_icon-dollar_badge"></span>
            <div class="text_wrapper">
              <div class="main_text">Minimum hourly rate (excluding Super)</div>
              <div class="additional_text">
                <span v-if="user.minRate">${{ user.minRate }}</span>
                <span v-else>$0</span>
              </div>
            </div>
          </div> -->
        </template>
        <template v-if="shouldShowTemplate">
          <div class="locum_status my-3" v-if="showCreateOptions('isRecordShiftsEnabled') && user.active">
            <div class="locum_card primary">
              <div class="text_wrapper text-center">
                <div class="main_text text-white">
                  {{ user.completedCancelledShiftsData.completedShiftsCount }}
                </div>
                <div class="additional_text text-white">
                  Completed Shifts
                </div>
              </div>
            </div>
            <div class="locum_card secondary">
              <div class="text_wrapper text-center">
                <div class="main_text text-white">
                  {{ user.completedCancelledShiftsData.cancelledShiftsCount }}
                </div>
                <div class="additional_text text-white">
                  Cancelled Shifts
                </div>
              </div>
            </div>
            <!-- <div class="locum_card">
              <div class="text_wrapper">
                <div class="main_text"><small>Cancellation Ratio</small></div>
                <div class="additional_text"> {{ user.completedCancelledShiftsData.cancellationRate }}% </div>
              </div>
            </div> -->
          </div>
          <div v-if="userSubscription == true">
            <div class="settings-separator"></div>
            <Subscription />
          </div>

          <div class="settings-separator"
            v-if="user.environmentValue.scriptsPerDay || user.environmentValue.average_scripts_saturday_id || user.environmentValue.average_scripts_sunday_id || user.environmentValue.software">
          </div>

          <div class="menu_item script-item" v-if="user.environmentValue.scriptsPerDay">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.66675 10.167H12.5001" stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5"
                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6.66675 13.5H10.3167" stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5"
                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M8.33341 5.00033H11.6667C13.3334 5.00033 13.3334 4.16699 13.3334 3.33366C13.3334 1.66699 12.5001 1.66699 11.6667 1.66699H8.33341C7.50008 1.66699 6.66675 1.66699 6.66675 3.33366C6.66675 5.00033 7.50008 5.00033 8.33341 5.00033Z"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M13.3333 3.34961C16.1083 3.49961 17.5 4.52461 17.5 8.33294V13.3329C17.5 16.6663 16.6667 18.3329 12.5 18.3329H7.5C3.33333 18.3329 2.5 16.6663 2.5 13.3329V8.33294C2.5 4.53294 3.89167 3.49961 6.66667 3.34961"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <div class="text_wrapper">
              <div class="main_text">Average scripts per day (weekdays)</div>
              <div class="additional_text">
                {{ user.environmentValue.scriptsPerDay }}
              </div>
            </div>
          </div>
          <div class="menu_item script-item" v-if="user.environmentValue.average_scripts_saturday_id">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.66675 10.167H12.5001" stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5"
                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6.66675 13.5H10.3167" stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5"
                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M8.33341 5.00033H11.6667C13.3334 5.00033 13.3334 4.16699 13.3334 3.33366C13.3334 1.66699 12.5001 1.66699 11.6667 1.66699H8.33341C7.50008 1.66699 6.66675 1.66699 6.66675 3.33366C6.66675 5.00033 7.50008 5.00033 8.33341 5.00033Z"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M13.3333 3.34961C16.1083 3.49961 17.5 4.52461 17.5 8.33294V13.3329C17.5 16.6663 16.6667 18.3329 12.5 18.3329H7.5C3.33333 18.3329 2.5 16.6663 2.5 13.3329V8.33294C2.5 4.53294 3.89167 3.49961 6.66667 3.34961"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <div class="text_wrapper">
              <div class="main_text">Average scripts on Saturday</div>
              <div class="additional_text">
                {{ user.environmentValue.average_scripts_saturday_id }}
              </div>
            </div>
          </div>
          <div class="menu_item script-item" v-if="user.environmentValue.average_scripts_sunday_id">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.66675 10.167H12.5001" stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5"
                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6.66675 13.5H10.3167" stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5"
                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M8.33341 5.00033H11.6667C13.3334 5.00033 13.3334 4.16699 13.3334 3.33366C13.3334 1.66699 12.5001 1.66699 11.6667 1.66699H8.33341C7.50008 1.66699 6.66675 1.66699 6.66675 3.33366C6.66675 5.00033 7.50008 5.00033 8.33341 5.00033Z"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M13.3333 3.34961C16.1083 3.49961 17.5 4.52461 17.5 8.33294V13.3329C17.5 16.6663 16.6667 18.3329 12.5 18.3329H7.5C3.33333 18.3329 2.5 16.6663 2.5 13.3329V8.33294C2.5 4.53294 3.89167 3.49961 6.66667 3.34961"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <div class="text_wrapper">
              <div class="main_text">Average scripts on Sunday</div>
              <div class="additional_text">
                {{ user.environmentValue.average_scripts_sunday_id }}
              </div>
            </div>
          </div>
          <div class="menu_item script-item" v-if="user.environmentValue.software">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.6666 18.3333H13.3333C16.6833 18.3333 17.2833 16.9917 17.4583 15.3583L18.0833 8.69167C18.3083 6.65833 17.7249 5 14.1666 5H5.83327C2.27494 5 1.6916 6.65833 1.9166 8.69167L2.5416 15.3583C2.7166 16.9917 3.3166 18.3333 6.6666 18.3333Z"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M6.66675 5.00033V4.33366C6.66675 2.85866 6.66675 1.66699 9.33341 1.66699H10.6667C13.3334 1.66699 13.3334 2.85866 13.3334 4.33366V5.00033"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M11.6666 10.8333V11.6667C11.6666 11.675 11.6666 11.675 11.6666 11.6833C11.6666 12.5917 11.6583 13.3333 9.99992 13.3333C8.34992 13.3333 8.33325 12.6 8.33325 11.6917V10.8333C8.33325 10 8.33325 10 9.16659 10H10.8333C11.6666 10 11.6666 10 11.6666 10.8333Z"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path d="M18.0417 9.16699C16.1167 10.567 13.9167 11.4003 11.6667 11.6837"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path d="M2.18335 9.3916C4.05835 10.6749 6.17502 11.4499 8.33335 11.6916"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <div class="text_wrapper">
              <div class="main_text">Dispensing Software</div>
              <div class="additional_text">
                {{ user.environmentValue.software }}<span v-if="user.environmentValue.software === 'Other'">: {{
                  user.settings.softwareOther }}</span>
              </div>
            </div>
          </div>

          <elment v-if="user.environmentValue.services.length > 0 && user.role !== 'agency'">
            <div class="settings-separator"></div>

            <div class="menu_item script-item">
              <div class="text_wrapper">
                <div class="menu_title mb-2">Services</div>
                <div class="additional_text d-flex flex-wrap gap-2">
                  <el-tag class="white inverted" v-for="service in user.environmentValue.services" :key="service">
                    {{ service.name }}
                  </el-tag>
                </div>
              </div>
            </div>
          </elment>          
        </template>
      </div>


      <div class="settings-separator" v-if="user.role == 'locum'"></div>

      <div class="settings_menu preferred_locum" v-if="user.role == 'locum'">
        <div class="menu_title">
          Preferred Pharmacies
        </div>
        <div>
          <el-button type="transparent" class="menu_item" data-testid="preferred-stores-btn"
            @click="links.goToManagePreferredLocum">
            <!-- <span class="locumate_icons locumate_icon-file-text "></span> -->
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.6666 6.87508V15.0001C16.6666 17.5001 15.175 18.3334 13.3333 18.3334H6.66665C4.82498 18.3334 3.33331 17.5001 3.33331 15.0001V6.87508C3.33331 4.16675 4.82498 3.54175 6.66665 3.54175C6.66665 4.05841 6.87496 4.52508 7.21662 4.86675C7.55829 5.20841 8.02498 5.41675 8.54165 5.41675H11.4583C12.4916 5.41675 13.3333 4.57508 13.3333 3.54175C15.175 3.54175 16.6666 4.16675 16.6666 6.87508Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M13.3334 3.54175C13.3334 4.57508 12.4917 5.41675 11.4584 5.41675H8.54169C8.02502 5.41675 7.55833 5.20841 7.21666 4.86674C6.875 4.52508 6.66669 4.05841 6.66669 3.54175C6.66669 2.50841 7.50835 1.66675 8.54169 1.66675H11.4584C11.975 1.66675 12.4417 1.87508 12.7834 2.21675C13.125 2.55842 13.3334 3.02508 13.3334 3.54175Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M6.66669 10.8333H10" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6.66669 14.1667H13.3334" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <div class="text_wrapper">
              <!-- <div class="main_text" v-if="isAustralia">Store List</div> -->
              <div class="main_text">Pharmacy List</div>
              <!-- <div class="additional_text" v-if="isAustralia">Manage your priority stores</div> -->
              <div class="additional_text">Manage your priority pharmacies</div>
            </div>
          </el-button>
        </div>
      </div>
      <div class="settings_menu preferred_locum" v-if="user.role == 'locum'">
        <div class="settings-separator"></div>
        <div class="menu_title">
          Preferred States
        </div>
        <div>
          <el-button type="transparent" class="menu_item" data-testid="preferred-states-btn"
            @click="links.goToPreferredState">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M10 6.66667V10L12.5 12.5" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="text_wrapper">
              <div class="main_text">Preferred States</div>
              <div class="additional_text">Select your preferred work states</div>
            </div>
          </el-button>
        </div>
      </div>
      <div class="settings_menu preferred_locum" v-if="user.role == 'locum'">
        <div class="settings-separator"></div>
        <div class="menu_title">
          Job Board Settings
        </div>
        <div>
          <el-button type="transparent" class="menu_item" data-testid="preferred-stores-btn"
            @click="links.jobBoardPreview">
            <!-- <span class="locumate_icons locumate_icon-file-text "></span> -->
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 21H7C3 21 2 20 2 16V8C2 4 3 3 7 3H17C21 3 22 4 22 8V16C22 20 21 21 17 21Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M14 8H19" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M15 12H19" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M17 16H19" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M8.49994 11.2899C9.49958 11.2899 10.3099 10.4796 10.3099 9.47992C10.3099 8.48029 9.49958 7.66992 8.49994 7.66992C7.50031 7.66992 6.68994 8.48029 6.68994 9.47992C6.68994 10.4796 7.50031 11.2899 8.49994 11.2899Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M12 16.33C11.86 14.88 10.71 13.74 9.26 13.61C8.76 13.56 8.25 13.56 7.74 13.61C6.29 13.75 5.14 14.88 5 16.33"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>


            <div class="text_wrapper">
              <!-- <div class="main_text" v-if="isAustralia">Store List</div> -->
              <div class="main_text">View Profile</div>
              <!-- <div class="additional_text" v-if="isAustralia">Manage your priority stores</div> -->
              <div class="additional_text">Manage your job board profile</div>
            </div>
          </el-button>
          <el-button type="transparent" class="menu_item" data-testid="preferred-stores-btn"
            @click="links.subscribe">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="22" height="22"
                viewBox="0 0 256.000000 256.000000" preserveAspectRatio="xMidYMid meet">
                <g transform="translate(0.000000,256.000000) scale(0.100000,-0.100000)" fill="#000000"
                    stroke="none">
                    <path
                        d="M1140 2205 l-121 -105 -235 0 c-143 0 -243 -4 -255 -10 -18 -10 -19 -24 -19 -223 l-1 -212 -129 -113 -130 -113 0 -577 c0 -436 3 -581 12 -590 14 -14 404 -17 426 -3 8 5 12 21 10 37 l-3 29 -153 3 c-100 2 -152 6 -150 13 2 6 111 143 243 305 l239 294 406 0 406 0 239 -295 c132 -162 241 -299 243 -305 3 -7 -186 -10 -592 -10 -585 0 -595 0 -606 -20 -8 -14 -8 -26 0 -40 11 -20 21 -20 663 -20 495 0 656 3 665 12 9 9 12 154 12 589 l0 578 -122 108 c-68 59 -126 112 -130 118 -4 5 -8 103 -8 217 0 195 -1 208 -19 218 -12 6 -112 10 -255 10 l-235 0 -121 105 c-67 58 -130 105 -140 105 -10 0 -73 -47 -140 -105z m205 -50 l60 -54 -125 0 -125 0 60 54 c33 30 62 55 65 55 3 0 32 -25 65 -55z m625 -529 l0 -384 -149 -111 -149 -111 -391 0 -391 0 -150 111 -150 111 0 384 0 384 690 0 690 0 0 -384z m-1460 -206 c0 -60 -3 -110 -6 -110 -4 0 -38 23 -76 51 l-69 51 43 37 c23 20 54 46 68 58 14 12 28 23 33 23 4 0 7 -49 7 -110z m1614 58 c34 -28 65 -55 69 -58 7 -7 -122 -110 -137 -110 -3 0 -6 50 -6 110 0 61 3 110 7 110 3 0 34 -23 67 -52z m-1562 -323 c123 -91 223 -170 223 -176 0 -12 -437 -557 -447 -558 -5 -1 -8 202 -8 449 0 248 2 450 5 450 2 0 105 -74 227 -165z m1668 -287 c0 -448 0 -452 -19 -433 -43 44 -441 540 -439 547 4 9 440 336 451 337 4 1 7 -203 7 -451z" fill="rgb(var(--locumate-primary-color))"/>
                    <path
                        d="M972 1868 c-8 -8 -12 -54 -12 -141 0 -157 -11 -186 -71 -187 -30 0 -47 17 -58 56 -4 15 -16 33 -28 41 -17 12 -23 11 -43 -5 -20 -16 -22 -24 -16 -57 10 -52 69 -111 119 -120 55 -11 121 17 152 63 24 35 25 44 25 187 0 154 -5 175 -40 175 -9 0 -21 -5 -28 -12z" fill="rgb(var(--locumate-primary-color))" />
                    <path
                        d="M1199 1857 c-55 -36 -69 -77 -69 -193 0 -88 3 -105 23 -134 36 -54 72 -75 127 -75 55 0 91 21 128 75 19 29 22 46 22 134 0 76 -4 110 -18 136 -25 50 -75 80 -132 80 -32 0 -58 -7 -81 -23z m129 -79 c20 -17 16 -197 -5 -220 -20 -22 -61 -23 -85 -1 -15 13 -18 32 -18 108 0 91 8 117 40 128 18 6 50 -1 68 -15z" fill="rgb(var(--locumate-primary-color))" />
                    <path
                        d="M1532 1868 c-8 -8 -12 -68 -12 -204 0 -158 3 -194 15 -204 21 -17 192 -9 223 11 28 17 62 79 62 111 0 13 -7 36 -15 52 -13 25 -13 33 2 76 15 42 15 51 2 86 -8 22 -29 48 -48 61 -29 20 -47 23 -125 23 -58 0 -96 -4 -104 -12z m179 -78 c21 -12 25 -50 7 -68 -7 -7 -36 -12 -65 -12 l-53 0 0 38 c0 21 3 42 7 45 10 11 82 8 104 -3z m13 -192 c20 -33 -4 -53 -68 -56 l-56 -3 0 41 0 41 56 -3 c41 -2 60 -8 68 -20z" fill="rgb(var(--locumate-primary-color))"/>
                    <path
                        d="M826 1357 c-38 -27 2 -95 42 -71 24 16 28 55 6 71 -10 7 -21 13 -24 13 -3 0 -14 -6 -24 -13z" fill="rgb(var(--locumate-primary-color))"/>
                    <path
                        d="M996 1354 c-19 -18 -21 -45 -4 -62 9 -9 110 -12 394 -12 334 0 385 2 398 16 21 20 20 30 -4 54 -19 19 -33 20 -394 20 -327 0 -377 -2 -390 -16z" fill="rgb(var(--locumate-primary-color))"/>
                    <path
                        d="M900 1175 c-10 -12 -10 -21 -2 -40 l12 -25 369 0 c360 0 371 1 381 20 8 14 8 26 0 40 -10 19 -21 20 -379 20 -319 0 -370 -2 -381 -15z" fill="rgb(var(--locumate-primary-color))"/>
                    <path d="M802 318 c-27 -27 -6 -68 35 -68 29 0 48 33 33 60 -12 22 -49 27 -68 8z" fill="rgb(var(--locumate-primary-color))"/>
                </g>
            </svg>
            <div class="text_wrapper">
              <div class="main_text">Job Alerts</div>
              <div class="additional_text">Subscribe to Job Alerts</div>
            </div>
          </el-button>
        </div>
        
      </div>
      <!-- check if pharmacy have subscription or pharmacy is in group and group have active subscription and also preferred locum is enabled in pharmacy then show preferred locum menu -->
      <!-- <div v-if="user.settings !== null && user?.settings.preferredLocumEnabled && (userSubscription==true || pharmacyIsInGroupAndGroupHaveSubscription == true)" class="settings_menu preferred_locum"> -->
      <div v-if="user.role === 'pharmacy' && user?.settings.preferredLocumEnabled" class="settings_menu preferred_locum">
        <div class="settings-separator"></div>
        <div class="menu_title">Preferred Locum</div>
        <div>
          <el-button type="transparent" class="menu_item" @click="links.goToManagePreferredLocum"
            data-testid="preferred-locum-btn">
            <span class="locumate_icons locumate_icon-file-text"></span>
            <div class="text_wrapper">
              <div class="main_text">{{ $filters.systemLocumName(false, true) }} Preferred List</div>
              <div class="additional_text">Manage your preferred {{ $filters.systemLocumName(false, false) }}</div>
            </div>
          </el-button>
        </div>
      </div>

      <div v-if="user.role === 'pharmacy' && (userSubscription==true || pharmacyIsInGroupAndGroupHaveSubscription == true)"
        class="settings_menu preferred_locum">
        <div class="settings-separator"></div>
        <div class="menu_title">Internal pool</div>
        <div>
          <el-button type="transparent" class="menu_item" @click="links.goToManageMultipleInternalPool"
            data-testid="preferred-locum-btn">
            <span class="locumate_icons locumate_icon-user-check"></span>
            <div class="text_wrapper">
              <div class="main_text">Internal Pool List</div>
              <div class="additional_text">Manage your internal pool</div>
            </div>
          </el-button>
        </div>
      </div>


      <!-- <div v-if="user.settings !== null && user?.settings.guestLocumEnabled && userSubscription== true"
        class="settings_menu guest_locum">
        <div class="settings-separator"></div>
        <div class="menu_title">Guest {{ $filters.capitalize(message.locum) }}</div>
        <div>
          <el-button type="transparent" class="menu_item" @click="links.goToManageGuestLocum"
            data-testid="guest-locum-btn">
            <span class="locumate_icons locumate_icon-file-text"></span>
            <div class="text_wrapper">
              <div class="main_text">Guest {{ $filters.capitalize(message.locum) }}</div>
              <div class="additional_text">Manage your guest {{ $filters.pluralize(message.locum) }}</div>
            </div>
          </el-button>
        </div>
      </div> -->
      <div class="settings-separator"></div>
      <div class="settings_menu">
        <div class="menu_title">Settings</div>
        <div>
          <el-button type="transparent" class="menu_item" @click="links.goToEarningReport"
            data-testid="earning-report-btn" v-if="user.role == 'locum' && isAustralia">
            <!-- <span class="locumate_icons locumate_icon-tree"></span> -->
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.42492 9.29175H6.21659C5.69159 9.29175 5.2666 9.71671 5.2666 10.2417V14.5084H8.42492V9.29175V9.29175Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M10.6344 5.5H9.36771C8.84271 5.5 8.41772 5.92501 8.41772 6.45001V14.5H11.5761V6.45001C11.5761 5.92501 11.1594 5.5 10.6344 5.5Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path d="M13.7901 10.7083H11.5818V14.5H14.7401V11.6583C14.7318 11.1333 14.3068 10.7083 13.7901 10.7083Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M7.50008 18.3334H12.5001C16.6667 18.3334 18.3334 16.6667 18.3334 12.5001V7.50008C18.3334 3.33341 16.6667 1.66675 12.5001 1.66675H7.50008C3.33341 1.66675 1.66675 3.33341 1.66675 7.50008V12.5001C1.66675 16.6667 3.33341 18.3334 7.50008 18.3334Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>

            <div class="text_wrapper">
              <div class="main_text">Earnings Report</div>
              <div class="additional_text">Check your earnings report</div>
            </div>
          </el-button>
          <el-button type="transparent" class="menu_item" @click="links.internalPoolUserUpdatePreference"
            data-testid="preferred-rate-btn"
            v-if="user.role == 'locum' && !user.internalEmployeeConvertedToFullLocum && user.isInternalLocum">
            <span class="locumate_icons locumate_icon-coin-dollar"></span>
            <div class="text_wrapper">
              <div class="main_text">Preferred rate</div>
              <div class="additional_text">
                Update your preferred rate per hour
              </div>
            </div>
          </el-button>
          <el-button type="transparent" class="menu_item" @click="links.onboardProfile"
            data-testid="convert-to-fulllocum-btn" :disabled="user.enableMarketplaceProcessComplete"
            v-if="user.isInternalLocum  && isAustralia && !user.internalEmployeeConvertedToFullLocum && user.role != 'pharmacy'">
            <span class="locumate_icons locumate_icon-user-check"></span>
            <div class="text_wrapper">
              <div class="main_text main_text--et d-flex">
                Enable Marketplace
                <span v-if="!user.enableMarketplaceProcessComplete"
                  class="locumate_icons locumate_icon-warning locumate_icons-red">
                </span>
              </div>
              <div class="additional_text">
                <template v-if="user.enableMarketplaceProcessComplete">
                  Awaiting verification
                </template>
                <template v-else>
                  Update your account settings to be a full locum
                </template>
              </div>
              <div class="additional_text additional_text--required">Ensure that all required details are completed, including
                submission of identity and insurance documents for verification
                by the admin
              </div>
            </div>
          </el-button>
          <el-button type="transparent" class="menu_item" @click="links.changeProfile" data-testid="account-btn" v-else>
            <!-- <span class="locumate_icons locumate_icon-gear"></span> -->
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.0007 10.0003C12.3018 10.0003 14.1673 8.13485 14.1673 5.83366C14.1673 3.53247 12.3018 1.66699 10.0007 1.66699C7.69946 1.66699 5.83398 3.53247 5.83398 5.83366C5.83398 8.13485 7.69946 10.0003 10.0007 10.0003Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M16.0085 13.1162L13.0585 16.0662C12.9418 16.1829 12.8335 16.3995 12.8085 16.5579L12.6502 17.6828C12.5919 18.0912 12.8752 18.3745 13.2835 18.3162L14.4085 18.1579C14.5668 18.1329 14.7919 18.0245 14.9002 17.9079L17.8502 14.9579C18.3585 14.4495 18.6002 13.8579 17.8502 13.1079C17.1085 12.3662 16.5169 12.6079 16.0085 13.1162Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path d="M15.584 13.541C15.834 14.441 16.534 15.141 17.434 15.391"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M2.8418 18.3333C2.8418 15.1083 6.05015 12.5 10.0002 12.5C10.8668 12.5 11.7001 12.625 12.4751 12.8583"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>


            <div class="text_wrapper">
              <div class="main_text">Account</div>
              <div class="additional_text">Update your account settings</div>
            </div>
          </el-button>
          <el-button type="transparent" class="menu_item" @click="links.agencyNoteList"
            v-if="user.role === 'agency' && user.isAgencyManager" data-testid="agency-note-btn">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.66675 10.167H12.5001" stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5"
                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6.66675 13.5H10.3167" stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5"
                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M8.33341 5.00033H11.6667C13.3334 5.00033 13.3334 4.16699 13.3334 3.33366C13.3334 1.66699 12.5001 1.66699 11.6667 1.66699H8.33341C7.50008 1.66699 6.66675 1.66699 6.66675 3.33366C6.66675 5.00033 7.50008 5.00033 8.33341 5.00033Z"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M13.3333 3.34961C16.1083 3.49961 17.5 4.52461 17.5 8.33294V13.3329C17.5 16.6663 16.6667 18.3329 12.5 18.3329H7.5C3.33333 18.3329 2.5 16.6663 2.5 13.3329V8.33294C2.5 4.53294 3.89167 3.49961 6.66667 3.34961"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <div class="text_wrapper">
              <div class="main_text">Fees & Notes</div>
              <div class="additional_text">Update fees and notes</div>
            </div>
          </el-button>
          <!-- <el-button type="transparent" class="menu_item" @click="links.goToSubscriptionDetails"
            v-if="user.role == 'pharmacy' && userSubscription == true" data-testid="subscription-btn">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.9166 15.8168H6.08325C5.73325 15.8168 5.34159 15.5418 5.22492 15.2085L1.77492 5.55846C1.28326 4.17513 1.85826 3.75013 3.04159 4.60013L6.29159 6.92513C6.83325 7.30013 7.44992 7.10846 7.68325 6.50013L9.14992 2.5918C9.61659 1.3418 10.3916 1.3418 10.8583 2.5918L12.3249 6.50013C12.5583 7.10846 13.1749 7.30013 13.7083 6.92513L16.7583 4.75013C18.0583 3.8168 18.6833 4.2918 18.1499 5.80013L14.7833 15.2251C14.6583 15.5418 14.2666 15.8168 13.9166 15.8168Z"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5.41675 18.334H14.5834" stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M7.91675 11.666H12.0834" stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>

            <div class="text_wrapper">
              <div class="main_text">Subscription</div>
              <div class="additional_text">Check your subscription details</div>
            </div>
          </el-button> -->
          <el-button v-if="user.role === 'locum' && isAustralia" type="transparent" class="menu_item"
            @click="links.bankAccount" data-testid="bank-account-btn">
            <!-- <span class="locumate_icons locumate_icon-library"></span> -->
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.42492 9.29175H6.21659C5.69159 9.29175 5.2666 9.71671 5.2666 10.2417V14.5084H8.42492V9.29175V9.29175Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M10.6344 5.5H9.36771C8.84271 5.5 8.41772 5.92501 8.41772 6.45001V14.5H11.5761V6.45001C11.5761 5.92501 11.1594 5.5 10.6344 5.5Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path d="M13.7901 10.7083H11.5818V14.5H14.7401V11.6583C14.7318 11.1333 14.3068 10.7083 13.7901 10.7083Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M7.50008 18.3334H12.5001C16.6667 18.3334 18.3334 16.6667 18.3334 12.5001V7.50008C18.3334 3.33341 16.6667 1.66675 12.5001 1.66675H7.50008C3.33341 1.66675 1.66675 3.33341 1.66675 7.50008V12.5001C1.66675 16.6667 3.33341 18.3334 7.50008 18.3334Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>

            <div class="text_wrapper">
              <div class="main_text">
                Bank Account
                <span v-if="user.bankVerification.verified == 1"
                  class="locumate_icons locumate_icon-check_badge locumate_icons-blue">
                  <label>verified</label>
                </span>
              </div>
              <div class="additional_text">
                Update your Bank Account details
              </div>
              <span v-if="!user.bankVerification.verified == 1 && user.isInternalLocum && user.locum_type != '5'"
                class="additional_text additional_text--required" v-text="'Required to become a full locum'" />
            </div>
          </el-button>

          

          <el-button v-if="user.role === 'locum' && isAustralia && user.billing?.billingAccountType === 2"
            type="transparent" class="menu_item" @click="links.super" data-testid="super-details-btn">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.6666 18.3333H13.3333C16.6833 18.3333 17.2833 16.9917 17.4583 15.3583L18.0833 8.69167C18.3083 6.65833 17.7249 5 14.1666 5H5.83327C2.27494 5 1.6916 6.65833 1.9166 8.69167L2.5416 15.3583C2.7166 16.9917 3.3166 18.3333 6.6666 18.3333Z"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M6.66675 5.00033V4.33366C6.66675 2.85866 6.66675 1.66699 9.33341 1.66699H10.6667C13.3334 1.66699 13.3334 2.85866 13.3334 4.33366V5.00033"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M11.6666 10.8333V11.6667C11.6666 11.675 11.6666 11.675 11.6666 11.6833C11.6666 12.5917 11.6583 13.3333 9.99992 13.3333C8.34992 13.3333 8.33325 12.6 8.33325 11.6917V10.8333C8.33325 10 8.33325 10 9.16659 10H10.8333C11.6666 10 11.6666 10 11.6666 10.8333Z"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path d="M18.0417 9.16699C16.1167 10.567 13.9167 11.4003 11.6667 11.6837"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path d="M2.18335 9.3916C4.05835 10.6749 6.17502 11.4499 8.33335 11.6916"
                stroke="rgb(var(--locumate-primary-color)" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <div class="text_wrapper">
              <div class="main_text">Super Details</div>
              <div class="additional_text">Update your Super details</div>
            </div>
          </el-button>

          <el-button v-if="user.role === 'locum'" type="transparent" class="menu_item" @click="links.blockedPharmacies"
            data-testid="blocked-pharmacies-btn">
            <!-- <span class="locumate_icons locumate_icon-denied"></span> -->
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.95834 2.04172C9.54167 1.55006 10.4833 1.55006 11.05 2.04172L12.3667 3.16672C12.6167 3.37506 13.0917 3.55006 13.425 3.55006H14.8417C15.725 3.55006 16.45 4.27506 16.45 5.15839V6.57506C16.45 6.90839 16.625 7.37506 16.8333 7.62506L17.9583 8.94172C18.45 9.52506 18.45 10.4667 17.9583 11.0334L16.8333 12.3501C16.625 12.6001 16.45 13.0667 16.45 13.4001V14.8167C16.45 15.7001 15.725 16.4251 14.8417 16.4251H13.425C13.0917 16.4251 12.625 16.6001 12.375 16.8084L11.0583 17.9334C10.475 18.4251 9.53334 18.4251 8.96667 17.9334L7.65 16.8084C7.4 16.6001 6.925 16.4251 6.6 16.4251H5.14167C4.25834 16.4251 3.53334 15.7001 3.53334 14.8167V13.3917C3.53334 13.0667 3.36667 12.5917 3.15834 12.3501L2.03334 11.0251C1.55 10.4501 1.55 9.51672 2.03334 8.94172L3.15834 7.61672C3.36667 7.36672 3.53334 6.90006 3.53334 6.57506V5.16672C3.53334 4.28339 4.25834 3.55839 5.14167 3.55839H6.58334C6.91667 3.55839 7.38334 3.38339 7.63334 3.17506L8.95834 2.04172Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M10 6.77502V10.8" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" />
              <path d="M9.99542 13.3334H10.0029" stroke="rgb(var(--locumate-primary-color))" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <div class="text_wrapper">
              <div class="main_text">Blocked Pharmacies</div>
            </div>
          </el-button>

          <el-button type="transparent" class="menu_item" @click="links.invoices"
            v-if="user.role !== 'agency' && isAustralia" data-testid="invoices-btn">
            <!-- <i class="locumate_icons locumate_icon-accounting_invoice"></i> -->
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.6665 10.167H12.4998" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6.66675 13.5H10.3167" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M8.33317 5.00033H11.6665C13.3332 5.00033 13.3332 4.16699 13.3332 3.33366C13.3332 1.66699 12.4998 1.66699 11.6665 1.66699H8.33317C7.49984 1.66699 6.6665 1.66699 6.6665 3.33366C6.6665 5.00033 7.49984 5.00033 8.33317 5.00033Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M13.3333 3.34961C16.1083 3.49961 17.5 4.52461 17.5 8.33294V13.3329C17.5 16.6663 16.6667 18.3329 12.5 18.3329H7.5C3.33333 18.3329 2.5 16.6663 2.5 13.3329V8.33294C2.5 4.53294 3.89167 3.49961 6.66667 3.34961"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <div class="text_wrapper">
              <div class="main_text">
                Invoices
              </div>
              <div class="additional_text">
                View invoice history
              </div>
            </div>
          </el-button>

          <el-button type="transparent" class="menu_item" data-testid="notifications-btn" @click="links.notifications">
            <!-- <i class="locumate_icons locumate_icon-notification_bell"></i> -->
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.0165 2.42578C7.25816 2.42578 5.0165 4.66745 5.0165 7.42578V9.83412C5.0165 10.3424 4.79983 11.1174 4.5415 11.5508L3.58316 13.1424C2.9915 14.1258 3.39983 15.2174 4.48316 15.5841C8.07483 16.7841 11.9498 16.7841 15.5415 15.5841C16.5498 15.2508 16.9915 14.0591 16.4415 13.1424L15.4832 11.5508C15.2332 11.1174 15.0165 10.3424 15.0165 9.83412V7.42578C15.0165 4.67578 12.7665 2.42578 10.0165 2.42578Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" />
              <path
                d="M11.5584 2.66719C11.3001 2.59219 11.0334 2.53385 10.7584 2.50052C9.95843 2.40052 9.19176 2.45885 8.4751 2.66719C8.71676 2.05052 9.31676 1.61719 10.0168 1.61719C10.7168 1.61719 11.3168 2.05052 11.5584 2.66719Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M12.5166 15.8828C12.5166 17.2578 11.3916 18.3828 10.0166 18.3828C9.33327 18.3828 8.69993 18.0995 8.24993 17.6495C7.79993 17.1995 7.5166 16.5661 7.5166 15.8828"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" />
            </svg>


            <div class="text_wrapper">
              <div class="main_text">Notifications</div>
              <div class="additional_text">
                Change notification options
              </div>
            </div>
          </el-button>
          <a :href="supportLink" target="_blank" class="el-button el-button--transparent menu_item"
            data-testid="support-btn">
            <!-- <span class="locumate_icons locumate_icon-support"></span> -->
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.3077 15.2753C18.3077 15.5753 18.241 15.8837 18.0993 16.1837C17.9577 16.4837 17.7744 16.767 17.5327 17.0337C17.1244 17.4837 16.6743 17.8087 16.166 18.017C15.666 18.2253 15.1244 18.3337 14.541 18.3337C13.691 18.3337 12.7827 18.1337 11.8243 17.7253C10.866 17.317 9.90768 16.767 8.95768 16.0753C7.99935 15.3753 7.09102 14.6003 6.22435 13.742C5.36602 12.8753 4.59102 11.967 3.89935 11.017C3.21602 10.067 2.66602 9.11699 2.26602 8.17533C1.86602 7.22533 1.66602 6.31699 1.66602 5.45033C1.66602 4.88366 1.76602 4.34199 1.96602 3.84199C2.16602 3.33366 2.48268 2.86699 2.92435 2.45033C3.45768 1.92533 4.04102 1.66699 4.65768 1.66699C4.89102 1.66699 5.12435 1.71699 5.33268 1.81699C5.54935 1.91699 5.74102 2.06699 5.89102 2.28366L7.82435 5.00866C7.97435 5.21699 8.08268 5.40866 8.15768 5.59199C8.23268 5.76699 8.27435 5.94199 8.27435 6.10033C8.27435 6.30033 8.21602 6.50033 8.09935 6.69199C7.99102 6.88366 7.83268 7.08366 7.63268 7.28366L6.99935 7.94199C6.90768 8.03366 6.86602 8.14199 6.86602 8.27533C6.86602 8.34199 6.87435 8.40033 6.89102 8.46699C6.91602 8.53366 6.94102 8.58366 6.95768 8.63366C7.10768 8.90866 7.36602 9.26699 7.73268 9.70033C8.10768 10.1337 8.50768 10.5753 8.94102 11.017C9.39102 11.4587 9.82435 11.867 10.266 12.242C10.6993 12.6087 11.0577 12.8587 11.341 13.0087C11.3827 13.0253 11.4327 13.0503 11.491 13.0753C11.5577 13.1003 11.6243 13.1087 11.6993 13.1087C11.841 13.1087 11.9493 13.0587 12.041 12.967L12.6743 12.342C12.8827 12.1337 13.0827 11.9753 13.2743 11.8753C13.466 11.7587 13.6577 11.7003 13.866 11.7003C14.0243 11.7003 14.191 11.7337 14.3743 11.8087C14.5577 11.8837 14.7494 11.992 14.9577 12.1337L17.716 14.092C17.9327 14.242 18.0827 14.417 18.1743 14.6253C18.2577 14.8337 18.3077 15.042 18.3077 15.2753Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" />
              <path
                d="M15.4167 7.50065C15.4167 7.00065 15.025 6.23398 14.4417 5.60898C13.9083 5.03398 13.2 4.58398 12.5 4.58398"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M18.3324 7.50033C18.3324 4.27533 15.724 1.66699 12.499 1.66699"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>


            <div class="text_wrapper">
              <div class="main_text">Support</div>
              <div class="additional_text">Contact the Support Team</div>
            </div>
          </a>
          <el-button type="transparent" class="menu_item" v-if="user.role == 'locum'"
            data-testid="documents-btn" @click="links.documents">
            <!-- <span class="locumate_icons locumate_icon-files-empty"></span> -->
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.1667 11.1666V13.6666C14.1667 16.9999 12.8334 18.3333 9.50002 18.3333H6.33335C3.00002 18.3333 1.66669 16.9999 1.66669 13.6666V10.4999C1.66669 7.16659 3.00002 5.83325 6.33335 5.83325H8.83335"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M14.1666 11.1666H11.5C9.49998 11.1666 8.83331 10.4999 8.83331 8.49992V5.83325L14.1666 11.1666Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M9.66669 1.66675H13" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5.83331 4.16675C5.83331 2.78341 6.94998 1.66675 8.33331 1.66675H10.5166"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M18.3333 6.66675V11.8251C18.3333 13.1167 17.2833 14.1667 15.9916 14.1667"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M18.3333 6.66675H15.8333C13.9583 6.66675 13.3333 6.04175 13.3333 4.16675V1.66675L18.3333 6.66675Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>

            <div class="text_wrapper">
              <div class="main_text">Documents</div>
              <span v-if="!docsComplete && user.isInternalLocum && user.locum_type != '5'"
                class="additional_text additional_text--required" v-text="'Required to become a full locum'" />
            </div>
          </el-button>
          <el-button type="transparent" class="menu_item" data-testid="about-btn" @click="links.goToCommonAbout">
            <!-- <span class="locumate_icons locumate_icon-question_circle"></span> -->
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.1666 15.3584H10.8333L7.12495 17.825C6.57495 18.1917 5.83329 17.8001 5.83329 17.1334V15.3584C3.33329 15.3584 1.66663 13.6917 1.66663 11.1917V6.19169C1.66663 3.69169 3.33329 2.02502 5.83329 2.02502H14.1666C16.6666 2.02502 18.3333 3.69169 18.3333 6.19169V11.1917C18.3333 13.6917 16.6666 15.3584 14.1666 15.3584Z"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M10 9.46667V9.29171C10 8.72504 10.35 8.42503 10.7 8.18336C11.0417 7.95003 11.3833 7.65004 11.3833 7.10004C11.3833 6.33337 10.7667 5.71667 10 5.71667C9.23334 5.71667 8.6167 6.33337 8.6167 7.10004"
                stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M9.99629 11.4584H10.0038" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <div class="text_wrapper">
              <div class="main_text">About</div>
            </div>
          </el-button>
          <div class="settings-separator mt-0"></div>
          <div class="d-flex justify-center">

            <el-button type="transparent" class="logout" @click="links.logout" data-testid="logout-btn">
              <!-- <span class="locumate_icons locumate_icon-close"></span> -->
              <div class="text_wrapper">
                <div class="main_text">Logout</div>
              </div>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, inject, computed, getCurrentInstance } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonTitle } from "@ionic/vue";

import { useStore } from "vuex";

import { useRouter } from "vue-router";

import { ElMessageBox } from "@/components/Vendor/Element";

import Subscription from "@/components/Subscription/Subscription";

import { isAustraliaRegion, isUSRegion } from '@/helpers/region/regionHelper.js';
import { formatAhpraDisplay } from "@/helpers/ahpra/ahpraDisplay.js";
import { checkDocs } from "@/utils/userDocs";

export default {
  components: {
    IonToolbar,
    IonTitle,
    Subscription
  },
  directives: {},
  setup() {
    let supportLink = ref(null);
    const $store = useStore();
    const $router = useRouter();
    const setPageClassGlobal = inject("setPageClassGlobal");
    const mainMenuShow = inject("mainMenuShow");
    const isAustralia = isAustraliaRegion();
    const message = inject('messages');
    const instance = getCurrentInstance();

    const user = $store.getters.GET_USER_DATA;
    const isUS = isUSRegion();
    const docsComplete = computed(() => checkDocs(user));
    console.log("🚀 ~ docsComplete:", docsComplete)
    const showCreateOptions = (option) => {
      if (user?.site[option]) {
        return true;
      }

      return false;
    };

    const userSubscription = ref(
      user.calculatedSubscriptions && user.calculatedSubscriptions.subscription
        ? user.calculatedSubscriptions.subscription
        : false
    );

    // check if pharmacy is in group and group have active subscription
    const pharmacyIsInGroupAndGroupHaveSubscription = ref(
      user.pharmacyGroupHasSubscription &&
        user.pharmacyGroupHasSubscription.subscription
        ? user.pharmacyGroupHasSubscription.subscription
        : false
    );

    /* @todo preferredLocumEnabled will be available from the api */
    if (user.preferredLocumEnabled === undefined) {
      user.preferredLocumEnabled = 1;
    }

    if (user.guestLocumEnabled === undefined) {
      user.guestLocumEnabled = 1;
    }
    
    const regex = /http:\/\/|https:\/\//gm;
    supportLink.value = user.supportSite.replace(regex, "");
    supportLink = `https://${supportLink.value}`;

    const registrationNumberMessage =  () => {
        if (process.env.VUE_APP_REGION === "AU") {
         return "Please indicate APHRA number";
        } else {
          return "Please indicate registration number";

        }
      }


      const shouldShowTemplate = computed(() => {
        if (isAustralia.value) {
          return user.role === "pharmacy" && instance?.appContext.config.globalProperties.$filters.employerType(user).isCommunityPharmacy;
        } else if (isUS.value) {
          return user.role === "pharmacy" && instance?.appContext.config.globalProperties.$filters.employerType(user); // No employerType check for US
        }
        return false; // Default case if neither isAU nor isUS
      });

    const links = {
      changeProfile: () => {
        $router.push({
          name: "profile_edit",
        });
      },
      onboardProfile: () => {
        $router.push({
          name: "onboard_name",
        });
      },
      changeBasicProfileOfIE: () => {
        $router.push({
          name: "basic_profile_edit_ie",
        });
      },
      changePhoto: () => {
        $router.push({
          name: "profile_photo",
        });
      },
      bankAccount: () => {
        if (user.role === "locum"  && user.airwallexInfo.beneficiaryId != null) {
          if (
            user.bankVerification.verified === 0 &&
            user.bankVerification.amount !== null
          ) {
            // if (user.bankVerification != null) {
            $router.push({
              name: "bank_account_verify",
            });
          } else {
            $router.push({
              name: "bank_account_change",
            });
          }
        } else {
          if (user.billing.bankAccountName == null) {
            $router.push({
              name: "bank_account",
            });
          } else {
            $router.push({
              name: "bank_account_change",
            });
          }
        }
      },
      invoices: () => {
        $router.push({
          name: "profile_invoices",
        });
      },
      notifications: () => {
        $router.push({
          name: "profile_notifications",
        });
      },
      documents: () => {
        $router.push({
          name: "profile_documents",
        });
      },
      gallery: () => {
        $router.push({
          name: "profile_gallery",
        });
      },
      goToCommonAbout: () => {
        $router.push({
          name: "common_about",
        });
      },
      super: () => {
        $router.push({
          name: "profile_super",
        });
      },
      goToPayment: () => {
        if (user.role === "locum") {
          $router.push({
            name: "profile_stripe_connect",
          });
        } else {
          $router.push({
            name: "profile_stripe_payment",
          });
        }
      },
      jobBoardPreview: () => {
        $router.push({
            name: "job_seeker_profile",
          });
      },

      goToManagePreferredLocum: () => {
        if (
          user.role === "pharmacy" &&
          user.settings !== null &&
          user?.settings.preferredLocumEnabled === 1
        ) {
          $router.push({
            name: "manage_preferred_locum",
          });
        } else if (user.role === "locum") {
          $router.push({
            name: "manage_preferred_locum_stores",
          });
        }
        return false;
      },
      goToPreferredState: () => {
        $router.push({
          name: "profile_preferred_state",
        });
      },
      goToManageMultipleInternalPool: () => {
       
          $router.push({
            name: "manage_multiple_internal_pool",
          });
       
      },

      goToManageGuestLocum: () => {
        if (
          user.role === "pharmacy" &&
          user.settings !== null &&
          user?.settings.guestLocumEnabled === true
        ) {
          $router.push({
            name: "manage_guest_locum",
          });
        } else if (user.role === "locum") {
          $router.push({
            name: "manage_guest_locum_stores",
          });
        }
        return false;
      },

      logout: () => {
        (async () => {
          try {
            await ElMessageBox.confirm(
              ``,
              "Are you sure you want to log out?",
              {
                distinguishCancelAndClose: true,
                showConfirmButton: true,
                confirmButtonText: "Logout",
                cancelButtonText: "Cancel",
                confirmButtonClass: "el-button--green",
                cancelButtonClass: "el-button--grey",
                showClose: true,
              }
            );
          } catch {
            return;
          }
          try {
            await $store.dispatch("AUTH_LOGOUT");
          } catch (error) {
            console.log(error);
          }
        })();
      },
      goToEarningReport: () => {
        $router.push({
          name: "profile_earning_report",
        });
      },
      internalPoolUserUpdatePreference: () => {
        $router.push({
          name: "internal_pool_user_update_preference",
        });
      },
      goToSubscriptionDetails: () => {
        $router.push({
          name: "profile_subscription_details",
        });
      },
      agencyNoteList: () => {
        $router.push({
          name: "profile_list_agency_note",
        });
      },
      blockedPharmacies:()=>{
        $router.push({
          name: "profile_blocked_pharmacies",
        });
      },
      subscribe: () => {
        $router.push({
            name: "subscribe_jobs",
        });
      }
    };

    onMounted(() => {
      setPageClassGlobal("global_profile_page");
      mainMenuShow(true);
    });

    console.log("agency profile", user);

    return {
      user,
      supportLink,
      links,
      userSubscription,
      isAustralia,
      registrationNumberMessage,
      formatAhpraDisplay,
      message,
      showCreateOptions,
      isUS,
      instance,
      shouldShowTemplate,
      pharmacyIsInGroupAndGroupHaveSubscription,
      docsComplete
    };
  },
};
</script>

<style scoped lang="scss">
.text_wrapper_shift {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0.5rem;
  .main_text_shift {
    color: rgb(121, 121, 121);
    font-size: 1.1rem;
    font-weight: 500;
  }

  .additional_text_shift {
    font-size: 1.2rem;
    font-weight: 400;
    text-align: center;
    display: block;
  }
}
</style>
